import React from 'react'
import { Container,Row ,Col} from 'react-bootstrap'
import ProductList from '../components/UI/ProductList'


const NewArrivals = ({data}) => {
    return (
        <section className='new__count'>
            <Container>
                <Row>
                    <Col lg='12' className='text-center mb-5'>
                        <h2 className='section__title'>New Arrivals</h2>
                    </Col>
                    <ProductList data={data}/>
                </Row>
            </Container>
        </section>
    )
}

export default NewArrivals